import { useTableFilter } from "@/shared"
import { useForm } from "react-hook-form"

export default function useTicketPendientesAsignacion() {
  const {
    pagination,
    setPagination
  } = useTableFilter()
  const form =useForm<any>({})
  const {
    formState:{errors},
    control, 
  }=useForm()
  

  return {
    pagination,
    setPagination,
    control, form, errors
  }
}